import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Hero from './hero';
import GalleryPreviewGrid from './galleries'

class Home extends Component {
    render() {
        return <div>
            <Hero />
            <Container>

            <div className="p-4 text-center">
                <h1>Welcome to Sportstar</h1>
                <p>Welcome to SportStar, a family-owned custom athletic uniform manufacturer proudly based in New Jersey since 1992. We design, dye, cut, and sew every uniform in-house—delivering unmatched quality, consistency, and customization.”</p>
            </div>
            
            </Container>

            <GalleryPreviewGrid />
        </div>
    }
}

export default Home;
